import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TrendingDownIcon, ClockIcon, CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function ProblemSlide() {
  return <SlideLayout data-id="element-353" data-mp="gy06u7dw54qp">
      <motion.div variants={itemVariants} className="mb-16" data-id="element-354" data-mp="gyi5tbrxtx2b">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-6" data-id="element-355" data-mp="kysckqnk0ri8">
          Your Workload Changed.{' '}
          <span className="text-brand-text-muted" data-id="element-356" data-mp="18o4tkcp4i3v3">The Hardware Didn't.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-357" data-mp="1dlwq5k0pqe5m">
        <motion.div variants={itemVariants} className="lg:col-span-7 space-y-8" data-id="element-358" data-mp="zui414bidwuc">
          <div className="flex gap-4 items-start" data-id="element-359" data-mp="13vtkaj8ht5pv">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-360" data-mp="13uigijf1rxyr">
              <ClockIcon className="w-6 h-6" data-id="element-361" data-mp="1wd5yhpyqywvm" />
            </div>
            <div data-id="element-362" data-mp="1weh0plcjnwkm">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-363" data-mp="1wf0jt5dxkr08">
                Your p99 Is a Coin Flip
              </h3>
              <p className="text-brand-text-dim leading-relaxed text-lg" data-id="element-364" data-mp="ied4m1j5ky7y">
                Shared, non-deterministic scheduling means the same request can
                take twice as long twice a day. Voice agents, trading systems,
                and anything with an SLA feel it first.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start" data-id="element-365" data-mp="161urbink9642">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-366" data-mp="12241bh5uyu0l">
              <TrendingDownIcon className="w-6 h-6" data-id="element-367" data-mp="1g1vddccte0by" />
            </div>
            <div data-id="element-368" data-mp="1b2iqwspuuv9w">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-369" data-mp="1b20n9b0v5ery">
                You Pay for Silicon You Never Use
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-370" data-mp="3hti5xiccu3aj">
                Real-time traffic runs at low batch sizes, where utilization
                sits at 20–30%. The other 70% is on your invoice.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start" data-id="element-371" data-mp="1lpbu37mc9o64">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-372" data-mp="1lry0h3xhtxmr">
              <CpuIcon className="w-6 h-6" data-id="element-373" data-mp="1ptrzl7s1itkt" />
            </div>
            <div data-id="element-374" data-mp="1urbapytfyq8j">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-375" data-mp="1urtj1ttdouwt">
                Built for Training, Borrowed for Inference
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-376" data-mp="24o6ccql0h6r1">
                GPUs won because they were already in the building — not because
                inference looks anything like training.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="lg:col-span-5" data-id="element-377" data-mp="2ig4cwd0npubl">
          <div className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden" data-id="element-378" data-mp="2ihxjjsb9sejl">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-teal/10 blur-3xl rounded-full" data-id="element-379" data-mp="2ncur0uswifud" />

            <div className="mb-6" data-id="element-380" data-mp="2xgrok6ctj6jm">
              <AlertCircleIcon className="w-8 h-8 text-brand-teal mb-4" data-id="element-381" data-mp="2sjrr2ju1bc44" />
              <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-382" data-mp="2nkya2hfjh2z7">
                The Industry is Moving
              </h3>
              <p className="text-brand-text-dim" data-id="element-383" data-mp="2jk4m5o23jo6b">
                ~30% of inference today already runs on non-GPU platforms
                (ASICs, custom silicon).
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-brand-border" data-id="element-384" data-mp="3bbk95j7kfcx2">
              <div className="text-5xl font-bold text-brand-teal mb-4" data-id="element-385" data-mp="36jkfg8i39g8x">50%</div>
              <p className="text-lg text-brand-text font-medium mb-1" data-id="element-386" data-mp="36hg08ueqoutc">
                of AI inference will run on non-GPU platforms by 2027
              </p>
              <p className="text-sm text-brand-text-muted" data-id="element-387" data-mp="2viruaudyml6">— Goldman Sachs</p>
            </div>
          </div>
        </motion.div>
      </div>
    </SlideLayout>;
}